import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=b80785ba&scoped=true"
import script from "./invoices.vue?vue&type=script&lang=js"
export * from "./invoices.vue?vue&type=script&lang=js"
import style0 from "./invoices.vue?vue&type=style&index=0&id=b80785ba&prod&scoped=true&lang=css"
import style1 from "./invoices.vue?vue&type=style&index=1&id=b80785ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80785ba",
  null
  
)

export default component.exports